import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import { AlbumFolderWithCreatorBrandDetails } from '../../../graphql/queries/album-folder';
import Spinner from '../../global/Spinner';
import useConsentManager from '../../../hooks/useConsentManager';
import GDPRFaceRecognitionConsentModal from '../../global/GDPRFaceRecognitionConsentModal';
import useAccount from '../../global/hooks/useAccount';

const RequireFaceRecognitionConsent = WrappedComponent => props => {
  const match = useRouteMatch();
  const { albumFolderId } = match?.params ?? {};
  // We use this to avoid having to refresh here, but the consent will be stored
  // on the client side's consent manager anyway.
  const [consentGiven, setConsentGiven] = useState(false);
  const { account } = useAccount();
  const { accountGeolocation, loadingAccountGeolocation } = useConsentManager({
    fetchAccountGeolocation: true,
  });
  const { face_recognition_consent: hasFaceRecConsent } =
    account?.privacy_settings ?? {};

  const { data: { albumFolder } = {}, loading } = useQuery(
    AlbumFolderWithCreatorBrandDetails,
    {
      variables: {
        id: albumFolderId,
      },
      skip: !albumFolderId,
    },
  );

  if (loading || loadingAccountGeolocation) {
    return (
      <div className="justify-content-center align-items-center">
        <Spinner />
      </div>
    );
  }

  const requiresFaceRecConsent = !accountGeolocation?.country?.is_gdpr;

  if (!hasFaceRecConsent && !consentGiven && requiresFaceRecConsent) {
    return (
      <div className="justify-content-center align-items-center">
        <Spinner />

        <GDPRFaceRecognitionConsentModal
          albumFolder={albumFolder}
          onAccept={() => setConsentGiven(true)}
          forceOpen
        />
      </div>
    );
  }

  return <WrappedComponent {...props} />;
};

export default RequireFaceRecognitionConsent;
